<template>
    <div class="m-ex">
        <div class="m-user"><user-info/></div>

        <div class="ex-view">
            <div class="header"></div>

            <div class="ex-pannel">
                <div class="score-info">
                    <div class="notice">获取积分可于商城内兑换奖励，积分仅在本期有效，请注意及时使用！</div>
                    <div class="score-detail" >本期剩余积分：<b>{{ score || 0 }}</b></div>
                </div>

                <div class="socre-ui">
                    <div class="u-btn" @click="$score_modal()">获取记录</div>
                    <div class="u-btn" @click="$record_modal()">兑换记录</div>
                    <div class="u-btn" @click="$rule_modal()">积分规则</div>
                </div>

                <div class="ex-shop">
                    <div class="exchange-item" v-for="(item,index) in shop_list" :key="'ex-item-' + index">
                        <h6>{{ item.giftName }}*{{ item.sendNum }}</h6>

                        <div class="goods-detail">
                            <div class="goods-wrapper">
                                <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>
                            </div>  
                        </div> 
                        
                        <div class="cnt">（{{ item.orderNum }}/{{ item.max }}）</div>
                        <div class="score">积分*{{ item.amt }}</div>

                        <div class="u-btn apply" :class="{'dismiss' : item.max == item.orderNum}" @click="exchange(item)"></div>

                        <div class="require" v-if="item.p1 > 0">参与阿斗期数≥{{ item.p1 }}</div>

                    </div>
                </div>

                <!-- 版本sp -->
                <!-- <div class="skin-gift">
                    <div class="title"></div>

                    <div class="skin-list">
                        <div class="skin-item" v-for="(item,index) in skin_config.skin_list" :key="index">
                            <div class="skin-detail">
                                <div class="skin-wrapper">
                                    <div class="skin-pic" v-tips="item.id"><game-item :locked="true" :id="item.id" :num="1"></game-item></div>
                                </div>
                            </div>
                            <div class="skin-status"></div>
                        </div>
                    </div>

                    <div class="skin-shop">
                        <div class="shop-item" v-for="n in 4" :key="n">
                            <h6>道具名称道具名称</h6>

                            <div class="goods-detail">
                                <div class="goods-wrapper">
                                    <div class="goods-pic" v-tips="'A001'"><game-item :locked="true" :id="'A001'" :num="1"></game-item></div>
                                </div>  
                            </div> 
                            
                            <div class="price">活动价<em class="icon-m3b"></em>99</div>
                            <div class="cnt">（0/1）</div>
                            
                            <div class="u-btn apply"></div>

                            <div class="require">解锁以上换装<b>{{ n }}</b>个可领取</div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import skin_config from '@/components/skindic.js'

export default {
    data (){
        return {
            shop_list : [],
            skin_config : skin_config,
            score: 0,
        }
    },
    computed:{
        ex_list (){
            return this.$store.state.ex_list;
        },        
    },
    watch: {
        ex_list : {
            handler(newVal, oldVal) {
                this.shop_list = newVal.filter(item => item.giftId != 'OE65' && item.giftId != 'MS83');
                this.get_score();
            },
            deep: true
        },                
    },        
    created (){
        this.render();
    },
    methods : {
        render (){
            this.$get(ajax_url_map.ex_buy_list,{
                success : (data) => {
                    this.shop_list = data.data.filter(item => item.giftId != 'OE65' && item.giftId != 'MS83');
                    this.$store.commit("$_setExList", this.shop_list);
                }
            })
        },
        see_offer (sid){
            this.$router.push({ name: 'detail', params: { sid: sid }});
        },         
        get_score(){
            this.$get(ajax_url_map.score_info,{
                success : (data) => {
                    if(JSON.stringify(data.data) != '{}')this.score = data.data['0'].score;
                }                
            },{
                type : 0,
            })
        },
        exchange(item){
            this.$comfirm_modal({ item : item })
        },
    },
}
</script>

<style lang="scss" scoped>
.m-ex{
    padding-top: 604px;
}

.m-user{
    width: 750px;
    height: 48px;
    line-height: 48px;
    margin: 0 auto;
    background-image: url(~@/assets/images/bg-userinfo.png);
}

.ex-view{
    width: 750px;
    // min-height: 2382px;
    padding-bottom: 200px;
    margin: 0 auto;
    background-image: url(~@/assets/images/task/bg-task.png);
    background-repeat: repeat-y;

    .header{
        width: 750px;
        height: 156px;
        margin: 0 auto 30px;
        background-image: url(~@/assets/images/ex/header-ex.png);
    }

    .goods-detail{
        .goods-wrapper{
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            width: 118px;
            height: 118px;
            background-image: url(~@/assets/images/shop/bg-item.png);
        }

        .goods-pic{
            width: 69px;
            height: 69px;
            border: 2px solid #ccae62;
        }
    }

}

.score-info{
    text-align: center;

    .notice{
        font-size: 22px;
        color: #dccdc1;
    }

    .score-detail{
        width: 690px;
        height: 50px;
        line-height: 50px;
        margin: 10px auto 0;
        color: #e5d98f;
        background-image: url(~@/assets/images/ex/bg-score.png);
    }
}

.socre-ui{
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    padding: 0 95px;
    color: #b48453;

    .u-btn{
        // width: 33.33%;
        text-decoration: underline;
        text-align: center;
    }
}

.ex-shop{
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 25px;
    padding: 0 22px;

    .exchange-item{
        position: relative;
        width: 211px;
        height: 485px;
        margin: 0 12px 10px;
        padding-top: 42px;
        background-image: url(~@/assets/images/ex/bg-exchange.png);
        text-align: center;

        h6{
            height: 2.5em;
            // margin-bottom: 10px;
            padding: 0 20px;
            font-size: 24px;
            font-weight: 700;
            color: #7f572d;
            overflow: hidden;
        }

        .goods-wrapper{
            margin: 0 auto;
        }

        .cnt{
            margin-top: 10px;
            color: #7f572d;
        }

        .score{
            margin-top: 10px;
            color: #a0938a;            
        }

        .require{
            margin-top: 5px;
            color: #7f572d;
        }

        .u-btn.apply{
            width: 192px;
            height: 69px;
            margin: 8px auto 0;
            background-image: url(~@/assets/images/ex/btn-exchange.png);

            &.disabled{
                background-image: url(~@/assets/images/ex/btn-exchange_disabled.png);
            }

            &.dismiss{
                background-image: url(~@/assets/images/ex/btn-exchange_dismiss.png);
            }            
        }
    }
}

.skin-gift{
    margin-top: 20px;
    .title{
        width: 750px;
        height: 77px;
        margin: 0 auto;
        background-image: url(~@/assets/images/ex/title-unlock.png);
    }

    .skin-list{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 689px;
        height: 181px;
        margin: 0 auto;
        padding: 0 18px;
        background-image: url(~@/assets/images/ex/bg-skin_group.png);
    }

    .skin-item{
        position: relative;

        &::after{
            display: block;
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba($color: #000000, $alpha: .4);
            pointer-events: none;
        }

        &.act::after{
            display: none;
        }

        .skin-status{
            position: absolute;
            left: 50%;
            bottom: -24px;
            transform: translateX(-50%);
            width: 48px;
            height: 48px;
            background-image: url(~@/assets/images/ex/status-default.png);
            z-index: 3;

            &.act{
                background-image: url(~@/assets/images/ex/status-get.png);
            }
        }
    }

    .skin-detail{
        .skin-wrapper{
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            width: 118px;
            height: 118px;
            background-image: url(~@/assets/images/shop/bg-item.png);
        }

        .skin-pic{
            width: 69px;
            height: 69px;
            border: 2px solid #ccae62;
        }
    }

}

.skin-shop{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 22px;
    padding: 0 30px;

    .shop-item{
        position: relative;
        width: 331px;
        height: 496px;
        padding-top: 44px;
        margin-bottom: 24px;
        text-align: center;
        background-image: url(~@/assets/images/ex/bg-skin.png);
    }

    h6{
        margin-bottom: 36px;
        padding: 0 20px;
        font-size: 24px;
        font-weight: 700;
        color: #7f572d;
        overflow: hidden;
    }

    .goods-wrapper{
        margin: 0 auto;
    }

    .price{
        position: absolute;
        top: 256px;
        left: 50%;
        transform: translateX(-50%);
        color: #7f572d;
    }

    .cnt{
        position: absolute;
        top: 280px;
        left: 50%;
        transform: translateX(-50%);
        color: #7f572d;
    }
    
    .u-btn.apply{
        position: absolute;
        bottom: 80px;
        left: 50%;
        transform: translateX(-50%);
        width: 232px;
        height: 89px;
        background-image: url(~@/assets/images/ex/btn-apply.png);     
    }
    .require{
        position: absolute;
        bottom: 45px;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        color: #7f572d;
    }

}
</style>